'use client';

import type { ClassValue } from 'clsx';
import type { ProductToCompareT } from '../../../../../type/product/productComparison';

import { ProductComparisonFooter as ComparisonFooter } from '@vs-shop/commerce-ui/productComparison';
import { clsxm } from '@vs-shop/utils';

import ProductComparisonFooterAddAllToCart from './ProductComparisonFooterAddAllToCart';
import ProductComparisonFooterClearAll from './ProductComparisonFooterClearAll';

type Props = {
  products: readonly ProductToCompareT[];
  className?: ClassValue;
};

export default function ProductComparisonFooter({ products, className }: Props) {
  return (
    <ComparisonFooter className={clsxm(className)}>
      <ProductComparisonFooterClearAll />
      <ProductComparisonFooterAddAllToCart products={products} />
    </ComparisonFooter>
  );
}
